// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle-fixed-width[data-v-537cd516]{width:70px}.credits-fixed-width[data-v-537cd516]{width:100px}", ""]);
// Exports
module.exports = exports;
